import { createWire } from '@forminator/react-wire'

export const tracts = createWire([])
export const currentTract = createWire(null)
export const recentTracts = createWire([])
export const favoriteTracts = createWire([])

